import { useMemo } from 'react';
import { useGetTemplatesQuery } from '@features/templates/store';

import type { UserTemplateItem } from '../../../types/types';

interface UseAppointmentTypeTemplatesOptions {
  skip?: boolean;
}

type V2TemplateSummary = {
  template: {
    id: string;
    owner_scope?: 'user' | 'org' | 'public' | string;
  };
  revision: {
    title?: string | null;
  };
};

export const toAppointmentTypeTemplateItem = (
  item: V2TemplateSummary,
): UserTemplateItem => ({
  template_id: item.template.id,
  display_name: item.revision.title || 'Untitled template',
  type: item.template.owner_scope === 'user' ? 'user' : 'public',
});

/**
 * Active note templates for appointment-type defaults.
 *
 * Appointment types only need the compact picker shape, but the source of
 * truth should be the V2 note-template list used by the templates route.
 */
export const useAppointmentTypeTemplates = (
  options: UseAppointmentTypeTemplatesOptions = {},
): UserTemplateItem[] => {
  const { data } = useGetTemplatesQuery(undefined, { skip: options.skip });

  return useMemo(
    () => (data?.templates ?? []).map(toAppointmentTypeTemplateItem),
    [data?.templates],
  );
};
